var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsefulUi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.014,
    height: 102.44,
    viewBox: "0 0 146.014 102.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    transform: "translate(1878.583 1130.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    transform: "translate(-1878.583 -1130.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    d: "M-1674.1-996.56h-140.373a2.807 2.807 0 0 1-2.821-2.787v-96.865a2.807 2.807 0 0 1 2.821-2.787h140.373a2.807 2.807 0 0 1 2.821 2.787v96.865a2.807 2.807 0 0 1-2.821 2.787zm-140.373-101.046a1.4 1.4 0 0 0-1.41 1.394v96.865a1.4 1.4 0 0 0 1.41 1.394h140.373a1.4 1.4 0 0 0 1.41-1.394v-96.865a1.4 1.4 0 0 0-1.41-1.394z",
    fill: "#017cee",
    "data-name": "Path 1043",
    transform: "translate(1817.292 1099)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(1.017 12.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_454",
    d: "M0 0h144.604v1.41H0z",
    fill: "#017cee",
    "data-name": "Rectangle 454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(6.333 5.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    cx: 1.675,
    cy: 1.675,
    r: 1.675,
    fill: "#017cee",
    "data-name": "Ellipse 113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(10.72)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    cx: 1.675,
    cy: 1.675,
    r: 1.675,
    fill: "#017cee",
    "data-name": "Ellipse 114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(5.36)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    cx: 1.675,
    cy: 1.675,
    r: 1.675,
    fill: "#017cee",
    "data-name": "Ellipse 115"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(10.554 23.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    d: "M-1750.077-1030.4v9.139h-35.87v-9.139h35.87m.145-1.41h-36.159a1.266 1.266 0 0 0-1.266 1.266v9.427a1.266 1.266 0 0 0 1.266 1.266h36.159a1.266 1.266 0 0 0 1.266-1.266v-9.427a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1044",
    transform: "translate(1787.358 1031.811)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(10.554 39.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    d: "M-1728.973-984.51v9.139h-56.974v-9.139h56.974m.144-1.41h-57.263a1.266 1.266 0 0 0-1.266 1.266v9.427a1.266 1.266 0 0 0 1.266 1.266h57.263a1.266 1.266 0 0 0 1.266-1.266v-9.427a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1045",
    transform: "translate(1787.358 985.92)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(10.554 54.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    d: "M-1664.254-938.618v31.649h-121.694v-31.649h121.694m.144-1.41h-121.982a1.266 1.266 0 0 0-1.266 1.266v31.938a1.266 1.266 0 0 0 1.266 1.266h121.982a1.266 1.266 0 0 0 1.266-1.266v-31.938a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1046",
    transform: "translate(1787.358 940.028)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(75.273 39.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    d: "M-1545.407-984.51v9.139h-56.974v-9.139h56.974m.144-1.41h-57.263a1.266 1.266 0 0 0-1.266 1.266v9.427a1.266 1.266 0 0 0 1.266 1.266h57.263a1.266 1.266 0 0 0 1.266-1.266v-9.427a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1047",
    transform: "translate(1603.792 985.92)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(53.466 23.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    d: "M-1628.365-1030.4v9.139h-35.87v-9.139h35.87m.144-1.41h-36.159a1.266 1.266 0 0 0-1.266 1.266v9.427a1.266 1.266 0 0 0 1.266 1.266h36.159a1.266 1.266 0 0 0 1.266-1.266v-9.427a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1048",
    transform: "translate(1665.646 1031.811)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(96.377 23.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    d: "M-1506.654-1030.4v9.139h-35.871v-9.139h35.871m.144-1.41h-36.159a1.266 1.266 0 0 0-1.266 1.266v9.427a1.266 1.266 0 0 0 1.266 1.266h36.159a1.266 1.266 0 0 0 1.266-1.266v-9.427a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1049",
    transform: "translate(1543.935 1031.811)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsefulUi);
export default __webpack_public_path__ + "static/media/UsefulUI.3e1417e50e31b999baf7e093b93638af.svg";
export { ForwardRef as ReactComponent };